"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, useTransition } from "react";
import { useLocale, useTranslations } from "next-intl";
import { Button } from "~/components/ui/button";
import { FormPrivacyNotice } from "~/app/_components/form-privacy-notice";
import { Input } from "~/components/ui/input";
import { joinWaitlist } from "../actions";
import { CheckCircle2, Loader2, Mail } from "lucide-react";
export function WaitlistForm() {
  const $ = _c(34);
  const t = useTranslations("waitlist");
  const locale = useLocale();
  const [isPending, startTransition] = useTransition();
  const [result, setResult] = useState(null);
  let t0;
  if ($[0] !== locale) {
    t0 = e => {
      e.preventDefault();
      const formData = new FormData(e.currentTarget);
      formData.set("locale", locale);
      if (typeof document !== "undefined" && document.referrer) {
        formData.set("referrer", document.referrer);
      }
      startTransition(async () => {
        const response = await joinWaitlist(formData);
        setResult(response);
      });
    };
    $[0] = locale;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleSubmit = t0;
  if (result?.success) {
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <CheckCircle2 className="h-12 w-12 text-green-600 dark:text-green-400" />;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    let t2;
    if ($[3] !== result.message) {
      t2 = <p className="text-center font-medium text-green-800 dark:text-green-200">{result.message}</p>;
      $[3] = result.message;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    let t3;
    if ($[5] !== t) {
      t3 = t("successSubtitle");
      $[5] = t;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    let t4;
    if ($[7] !== t3) {
      t4 = <p className="text-center text-sm text-green-600 dark:text-green-400">{t3}</p>;
      $[7] = t3;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    let t5;
    if ($[9] !== t2 || $[10] !== t4) {
      t5 = <div className="flex flex-col items-center gap-4 rounded-2xl border border-green-200 bg-green-50 p-6 dark:border-green-800 dark:bg-green-950/30">{t1}{t2}{t4}</div>;
      $[9] = t2;
      $[10] = t4;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    return t5;
  }
  let t1;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Mail className="absolute top-1/2 left-3 h-5 w-5 -translate-y-1/2 text-gray-400" />;
    $[12] = t1;
  } else {
    t1 = $[12];
  }
  let t2;
  if ($[13] !== t) {
    t2 = t("emailPlaceholder");
    $[13] = t;
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  let t3;
  if ($[15] !== isPending || $[16] !== t2) {
    t3 = <div className="relative flex-1">{t1}<Input type="email" name="email" placeholder={t2} required={true} disabled={isPending} className="h-12 pl-10 text-base" /></div>;
    $[15] = isPending;
    $[16] = t2;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  let t4;
  if ($[18] !== isPending || $[19] !== t) {
    t4 = isPending ? <><Loader2 className="mr-2 h-4 w-4 animate-spin" />{t("submitting")}</> : t("submit");
    $[18] = isPending;
    $[19] = t;
    $[20] = t4;
  } else {
    t4 = $[20];
  }
  let t5;
  if ($[21] !== isPending || $[22] !== t4) {
    t5 = <Button type="submit" disabled={isPending} className="h-12 border-0 bg-gradient-to-r from-blue-600 to-teal-400 px-6 text-white hover:opacity-90 hover:shadow-lg">{t4}</Button>;
    $[21] = isPending;
    $[22] = t4;
    $[23] = t5;
  } else {
    t5 = $[23];
  }
  let t6;
  if ($[24] !== t3 || $[25] !== t5) {
    t6 = <div className="flex flex-col gap-3 sm:flex-row">{t3}{t5}</div>;
    $[24] = t3;
    $[25] = t5;
    $[26] = t6;
  } else {
    t6 = $[26];
  }
  let t7;
  if ($[27] !== result) {
    t7 = result && !result.success && <p className="text-center text-sm text-red-600 dark:text-red-400">{result.message}</p>;
    $[27] = result;
    $[28] = t7;
  } else {
    t7 = $[28];
  }
  let t8;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <FormPrivacyNotice variant="waitlist" />;
    $[29] = t8;
  } else {
    t8 = $[29];
  }
  let t9;
  if ($[30] !== handleSubmit || $[31] !== t6 || $[32] !== t7) {
    t9 = <form onSubmit={handleSubmit} className="flex w-full max-w-md flex-col gap-4">{t6}{t7}{t8}</form>;
    $[30] = handleSubmit;
    $[31] = t6;
    $[32] = t7;
    $[33] = t9;
  } else {
    t9 = $[33];
  }
  return t9;
}